/**
 * Utility: className merger using clsx + tailwind-merge.
 * tailwind-merge ensures conflicting Tailwind classes resolve correctly
 * (e.g., `cn('px-2', 'px-4')` → 'px-4', not 'px-2 px-4').
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
